<template>
  <div class="app-container">
    <account-navbar />
    <a-layout class="app-content position-relative h-100">
      <account-sidebar />
      <a-layout-content>
        <div id="app-page" class="app-page" :class="{ 'l2-menu-show': l2MenuVisible }">
          <router-view />
        </div>
      </a-layout-content>
      <a-layout-footer class="text-center footer">
        © Copyright 北京云联壹云技术有限公司
      </a-layout-footer>
    </a-layout>
  </div>
</template>

<script>
import AccountNavbar from '../Navbar'
import AccountSidebar from '../Sidebar'

export default {
  name: 'AccountDefaultLayout',
  components: {
    AccountNavbar,
    AccountSidebar,
  },
  data () {
    return {
      l2MenuVisible: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.app-content {
  position: relative;
  padding-top: 60px;
  background-color: #fff;
}
.app-page {
  margin-bottom: 70px;
  margin-left: 200px;
  padding: 15px;
  padding-bottom: 100px;
}
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>
